import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Tooltip, useToast } from '@plaidev/sour-react';
import type { ComponentProps } from 'react';
import type {} from 'react/jsx-runtime';

export type ClipboardCopyButtonProps = {
  /** クリップボードに書き込む文字列 */
  text: string;
  /** アイコンボタンのアクセシブル名 */
  ariaLabel: string;
  tooltipContent?: string;
  successToastMessage?: string;
  errorToastMessage?: string;
} & Pick<ComponentProps<typeof IconButton>, 'className' | 'disabled' | 'size' | 'variant'>;

export function ClipboardCopyButton({
  text,
  ariaLabel,
  tooltipContent = 'クリップボードにコピー',
  successToastMessage = 'コピーしました',
  errorToastMessage = 'コピーに失敗しました',
  className,
  disabled,
  size = 'sm',
  variant = 'quiet',
}: ClipboardCopyButtonProps) {
  const toast = useToast();

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(successToastMessage);
    } catch {
      toast.error(errorToastMessage);
    }
  };

  return (
    <Tooltip content={tooltipContent}>
      <span className="inline-flex shrink-0">
        <IconButton
          aria-label={ariaLabel}
          className={className}
          disabled={disabled}
          size={size}
          type="button"
          variant={variant}
          onClick={() => void handleClick()}
        >
          <FontAwesomeIcon icon={faCopy} className="size-4" aria-hidden />
        </IconButton>
      </span>
    </Tooltip>
  );
}
